import styled from 'styled-components';

export const Content = styled.main`
  padding: 0px 0px 0px 340px;
  min-height: 600px;

  @media (max-width: 1024px) {
    padding: 2.5rem 0 0 0;
    overflow-x: hidden;
  }
`;

export const LoadArea = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
